// "Get AI summary" in the footer: each assistant opens in a new tab with a
// prompt asking it to summarise the page the visitor is on. `{prompt}` is
// replaced with the URL-encoded prompt, and `{url}` with the page's
// canonical URL (the production host, as in seo.util.ts).
export const aiSummary = {
  heading: "Get AI summary",
  siteUrl: "https://fydo.in",
  prompt:
    "Summarise this page from Fydo and explain how it could help my business: {url}",
  // {name} is the assistant's name.
  linkLabel: "Summarise this page with {name} (opens in a new tab)",
  assistants: [
    {
      name: "ChatGPT",
      icon: "/icons/ai/chatgpt.svg",
      href: "https://chatgpt.com/?q={prompt}",
    },
    {
      name: "Claude",
      icon: "/icons/ai/claude.svg",
      href: "https://claude.ai/new?q={prompt}",
    },
    {
      name: "Perplexity",
      icon: "/icons/ai/perplexity.svg",
      href: "https://www.perplexity.ai/search/new?q={prompt}",
    },
  ],
};
